"use client"

import React from "react"
import UnifiedLayout from "./ui/dashboard/UnifiedLayout"
import RestaurantSidebar from "./RestaurantSidebar"
import { useRestaurantAuth } from "../contexts/RestaurantAuthContext"
import { useLanguage } from "../contexts/LanguageContext"

interface RestaurantLayoutProps {
  children: React.ReactNode
}

const RestaurantLayout: React.FC<RestaurantLayoutProps> = ({ children }) => {
  const { user, logout } = useRestaurantAuth()
  const { t } = useLanguage()

  return (
    <UnifiedLayout
      sidebar={<RestaurantSidebar />}
      user={user ? {
        username: user.name,
        role: user.role || t("restaurantOwner")
      } : null}
      onLogout={logout}
      title={t("restaurantDashboard")}
      subtitle={t("manageRestaurantOperations")}
      profilePath={user?.restaurant?._id ? `/restaurant/${user.restaurant._id}/profile` : "/restaurant/profile"}
      isRestaurant={true}
      restaurantId={user?.restaurant?._id}
    >
      {children}
    </UnifiedLayout>
  )
}

export default RestaurantLayout 